<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Stores
	import { home_data } from 'src/stores/account/user';

	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { save_home } from 'src/helpers/home_helpers';

	//Design system components
	import { Alert, AlertV2, Text, ToggleV2 } from '@Shelly/shelly-design-system';

	let checked = $home_data.bgBtScan == undefined ? true : $home_data?.bgBtScan?.enable;

	let disabled = false;

	const save = async (nextChecked: boolean) => {
		checked = nextChecked;

		save_home('bgBtScan', {
			enable: checked,
		});

		home_data.set({
			...$home_data,
			bgBtScan: {
				enable: checked,
			},
		});
	};
</script>

<div class="d-flex justify-content-between align-items-center gap-m mb-m">
	<div class="min-width-0">
		<Text styleType="body" class="mb-s">
			{capFirstChar($format('background_devices_scan', { default: 'Background Scan' }))}
		</Text>
		<Text styleType="body-small" class="text-color-muted">
			{$format('input_toggle_background_scan_setting', {
				default: 'Enable background scan for new devices',
			})}
		</Text>
	</div>

	<ToggleV2
		id="toggle-background-scan"
		{checked}
		size="m"
		{disabled}
		on:click={() => save(!checked)}
		aria-label={$format('background_devices_scan', { default: 'Background Scan' })}
	/>
</div>

<Alert
	class="mb-m"
	type="warning"
	isHeadingBold
	heading={capFirstChar(
		$format('alert_warning_generic_attention', {
			default: 'Attention!',
		}),
	)}
	message={capFirstChar(
		$format('alert_warning_message_background_scan_setting', {
			default:
				'In order to use this feature, the app must have location and Bluetooth permission enabled.',
		}),
	)}
/>

<AlertV2
	heading={capFirstChar(
		$format('alert_info_background_scan_setting', {
			default:
				'When enabled, the app will look for new devices in the background and prompt on discovery. This may consume more battery.',
		}),
	)}
/>
